import { useCallback, useState } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { showNotification } from 'app/providers/NotificationsProvider';
import { useSendContractByEmailMutation } from 'entities/Contract';

interface HookApi {
  send: (contractId: string) => void;
  isOpenedConfirm: boolean;
  isLoading: boolean;
  openConfirmModal: () => void;
  closeConfirmModal: () => void;
}

export const useSendContractByEmail = (): HookApi => {
  const [isOpenedConfirm, setOpenedConfirm] = useState(false);

  const { t } = useAppTranslation('common');

  const [sendContract, { isLoading }] = useSendContractByEmailMutation();

  const openConfirmModal = useCallback((): void => {
    setOpenedConfirm(true);
  }, []);

  const closeConfirmModal = useCallback((): void => {
    setOpenedConfirm(false);
  }, []);

  const send = useCallback(
    async (contractId: string): Promise<void> => {
      try {
        await sendContract(contractId).unwrap();

        showNotification('info', t('Success'), t('Contract has been successfully sent'));
      } catch (error: CustomAny) {
        console.log(error);
        showNotification('error', t('Error'), t('Error when sending contract'));
      } finally {
        closeConfirmModal();
      }
    },
    [closeConfirmModal, sendContract, t],
  );

  return {
    send,
    openConfirmModal,
    closeConfirmModal,
    isOpenedConfirm,
    isLoading,
  };
};
